<template>
  <div class="widget-2 panel no-border bg-primary widget">
    <div class="panel-body" v-if="main_agency != undefined">
      <div class="pull-bottom padding-20" v-if="this.agencies.length">
        <h3 class="text-white">Agence <br>{{main_agency.name}}</h3>
        <ul>
          <li>{{main_agency.street_line1}}</li>
          <li v-if="main_agency.street_line2">{{main_agency.street_line2}}</li>
          <li>{{main_agency.zipcode}} {{main_agency.decoded_country}}</li>
        </ul>
        <ul>
          <li>Téléphone : {{main_agency.phone}}</li>
          <li>Permanence Téléphonique : {{main_agency.final_hotline_phone}}</li>
          <!-- <li>Fax : 01 55 55 55 26</li>
          <li>Email : opera@sofradom.com</li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .widget-2 {
    height: 350px !important;
    text-align: left;
    padding: 0 0 20px;
    margin: 0;
    width: 100%;
    &::after {
      background: url('~assets/img/dashboard/dashboard.jpg') 0% 0% no-repeat / cover;
    }
    ul {
      &:first-of-type {
        padding-bottom: 10px;
      }
      &:last-of-type {
        margin: 0;
      }
      li {
        line-height: 18px;
      }
    }
  }
</style>

<script type="text/babel">
  export default {
    name: "Agency",
    props:["agencies"],

    computed:{
      main_agency (){
        return _.find(this.agencies, (agency) => !agency.virtual)
      },

    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/Agency.vue